var BlockFlip = Object.getPrototypeOf(app).BlockFlip = new Component("block-flip");
BlockFlip.debug = false;
BlockFlip.createdAt      = "1.0.0";
BlockFlip.lastUpdate     = "1.4.12";
BlockFlip.version        = "1.1";



// WEBPACK FOOTER //
// ./src/components/block-flip/block-flip.js